import { LinkListSectionVariant } from '../LinkListSectionVariant.csharp';
import type { LinkListSectionBaseViewModel } from '../ViewModel/LinkListSectionBaseViewModel.csharp';
import type { LinkListSectionItemViewModel } from '../ViewModel/LinkListSectionItemViewModel.csharp';
import type { LinkListSectionPlainViewModel } from '../ViewModel/LinkListSectionPlainViewModel.csharp';
import type { LinkListSectionWithTabsViewModel } from '../ViewModel/LinkListSectionWithTabsViewModel.csharp';

export const isLinkListWithTabs = (
    viewModel: LinkListSectionBaseViewModel
): viewModel is LinkListSectionWithTabsViewModel => viewModel.type === 'withTabs';

export const isPlainLinkList = (viewModel: LinkListSectionBaseViewModel): viewModel is LinkListSectionPlainViewModel =>
    viewModel.type === 'plain';

export const mapSectionItems = (items: LinkListSectionItemViewModel[]) =>
    items.map(sectionItem => ({
        ...sectionItem.link,
        notes: sectionItem.additionalNotes?.filter(note => note) ?? [],
    }));

export const getShortcutColorVariant = (variant: LinkListSectionVariant) => {
    switch (variant) {
        case LinkListSectionVariant.Primary:
            return 'primary';
        case LinkListSectionVariant.Dark:
            return 'light';
        default:
            return 'dark';
    }
};
